import type { SvgIconComponent } from '@mui/icons-material';
import { ZERO_ICONS } from '../../constants/zeroIcons';
import { StatisticType } from '../../types/dashboard.type';

/** One icon per operational statistic (classification only, never colour). */
export const STAT_ICONS: Partial<Record<StatisticType, SvgIconComponent>> = {
  [StatisticType.TOTAL_ORDERS]: ZERO_ICONS.collections,
  [StatisticType.COMPLETION_RATE]: ZERO_ICONS.completed,
  [StatisticType.CANCELLATION_RATE]: ZERO_ICONS.cancelled,
  [StatisticType.WASTE_DIVERSION_RATE]: ZERO_ICONS.rate,
  [StatisticType.AVERAGE_CONTAINER_FILL_RATE]: ZERO_ICONS.mass,
  [StatisticType.TRIPS_TODAY_COUNT]: ZERO_ICONS.clock,
  [StatisticType.COMPLETED_WASTE_AMOUNT]: ZERO_ICONS.waste,
  [StatisticType.TOTAL_WASTE_AMOUNT]: ZERO_ICONS.mass,
  [StatisticType.SUSTAINABLE_SUPPLY]: ZERO_ICONS.waste,
  [StatisticType.RECYCLER_APPETITE]: ZERO_ICONS.mass,
  [StatisticType.FULL_PERCENTAGE]: ZERO_ICONS.alarmFull,
  [StatisticType.TOTAL_REVENUE]: ZERO_ICONS.revenue,
  [StatisticType.AVERAGE_INCENTIVE_PER_KG]: ZERO_ICONS.revenue,
  [StatisticType.WASTE_TYPE_BREAKDOWN]: ZERO_ICONS.materials,
  [StatisticType.INCOMING_WASTE_BREAKDOWN]: ZERO_ICONS.daily,
};

export function statIcon(stat: string): SvgIconComponent {
  return STAT_ICONS[stat as StatisticType] ?? ZERO_ICONS.insights;
}
